module.exports = __webpack_public_path__ + "media/card.77b02ec2.mp3";